/**
 * Cvent Privacy Policies per language
 */
export default {
  'en-US': 'http://www.cvent.com/en/privacy-policy-global.shtml#cookies',
  'da-DK': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-danish.shtml#cookies',
  'fr-FR': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-french.shtml#cookies',
  'it-IT': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-italian.shtml#cookies',
  'pl-PL': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-polish.shtml#cookies',
  'es-ES': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-spanish.shtml#cookies',
  'bg-BG': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-bulgarian.shtml#cookies',
  'nl-NL': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-dutch-netherlands.shtml#cookies',
  'de-DE': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-german.shtml#cookies',
  'lv-LV': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-latvian.shtml#cookies',
  'ro-RO': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-romanian.shtml#cookies',
  'sv-SE': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-swedish.shtml#cookies',
  'sv-FI': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-swedish.shtml#cookies',
  'hr-HR': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-croatian.shtml#cookies',
  'et-EE': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-estonian.shtml#cookies',
  'el-GR': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-greek.shtml#cookies',
  'lt-LT': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-lithuanian.shtml#cookies',
  'sk-SK': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-slovakian.shtml#cookies',
  'tr-TR': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-turkish-cypress.shtml#cookies',
  'cs-CZ': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-czech.shtml#cookies',
  'fi-FI': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-finnish.shtml#cookies',
  'hu-HU': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-hungarian.shtml#cookies',
  'mt-MT': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-maltese.shtml#cookies',
  'sl-SI': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-slovenian.shtml#cookies'
};
